import * as React from 'react';
import { useGetOrganizationLazyQuery } from '../../../models/graphql';
import { WorkspacesController } from './Workspaces.controller';

export const WorkspacesApollo = (): JSX.Element => {
  const [getOrganizationQuery, organizationResults] = useGetOrganizationLazyQuery();

  return (
    <WorkspacesController
      {...{
        getOrganization: getOrganizationQuery,
        organizationResults
      }}
    />
  );
};
